module.exports = __webpack_public_path__ + "media/site_templates/www.guttercleaning.biz/images/our_services_2-ccfdbfcd4daaa948ffa4c8892135226b.jpg";